<div>
  <router-outlet></router-outlet>
  <app-something-went-wrong-modal
  *ngrxLet="somethingWentWrongModalOpen$ as somethingWentWrongModalOpen"
  [visible]="somethingWentWrongModalOpen"
  (modalClose)="closeModal()"
></app-something-went-wrong-modal>
</div>

